import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '20px 40px 24px'
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px'
  },
  input: {
    fontSize: '14px',
    color: '#545455',
    width: '100%',

    '& svg': {
      '@media (min-width: 3000px)': {
        top: 'calc(50% - 20px)'
      }
    }
  },
  underline: {
    '&::before': {
      borderColor: 'rgba(0, 0, 0, 0.42)'
    }
  },
  cardsWrapper: {
    margin: '30px 42px',
    padding: '10px 20px 30px'
  },
  inputWrapper: {
    width: '100%',
    marginTop: '20px',
    position: 'relative'
  },
  dateTimeInput: {
    width: '100%',
    marginTop: '20px',
    position: 'relative'
  },
  paper: {
    maxHeight: '200px',
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: '5px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  formWrapper: {
    display: 'flex',
    flexDirection: 'column'
  },
  durationPart: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  vppPart: {
    marginTop: '40px'
  },
  vppLabel: {
    color: '#6F6F6F',
    opacity: 0.6,
    fontSize: '16px'
  },
  vppListContent: {
    border: '1px solid #70707033',
    borderRadius: '8px',
    padding: '12px 20px',
    width: '18%',
    marginRight: '2%',
    marginTop: '2%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',

    '@media (max-width: 1023px)': {
      width: '40%'
    },
    '@media (max-width: 767px)': {
      width: '90%',
      marginTop: '12px'
    }
  },
  selectedVpp: {
    border: '1px solid #F37320',
  },
  vppWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: '10px'
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '30px',
    justifyContent: 'space-between',
    marginLeft: 'auto',
    marginTop: '22px',
    marginBottom: '22px',

    '@media (max-width: 767px)': {
      width: '100%'
    }
  },
  button: {
    width: '150px',
    height: '36px',
    textTransform: 'capitalize',
    margin: 0,
    marginLeft: '25px'
  },
  hr: {
    marginTop: '100px',
    border: '1px solid #D8D8D8',
    width: '100%',

    '@media (max-width: 767px)': {
      marginTop: '50px'
    }
  },
  checkBoxLabelWrapper: {
    width: '80%'
  },
  checkBoxLabel: {
    color: '#545455',
    fontSize: '14px',
    textTransform: 'capitalize',
    wordBreak: 'break-word',
    fontWeight: 600
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '4px'
  },
  label: {
    color: '#6F6F6F',
    opacity: 0.6,
    fontSize: '10px',
    width: '55%'
  },
  value: {
    color: '#000000',
    opacity: 0.6,
    fontSize: '10px',
    width: '48%'
  },
  yourSectionWrapper: {
    marginTop: '40px'
  },
  yourSectionTitleWrapper: {
    background: '#F7F7F7',
    padding: '12px 30px'
  },
  yourSectionTitle: {
    color: '#F37320',
    fontSize: '16px'
  },
  rowWrapper: {
    display: 'flex',
    width: '40%',
    flexWrap: 'wrap',
    justifyContent: 'space-between',

    '@media (max-width: 1023px)': {
      width: '65%'
    },
    '@media (max-width: 767px)': {
      width: '100%',
      flexDirection: 'column'
    }
  },
  sectionRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    //marginTop: '18px',
    //width: '45%',

    '@media (max-width: 767px)': {
      width: '100%'
    }
  },
  yourSectionContentWrapper: {
    padding: '0 30px'
  },
  sectionValue: {
    color: '#000000',
    opacity: 0.6,
    fontSize: '12px',
    //width: '28%',
    textAlign: 'right',
    wordBreak: 'break-word'
  },
  sectionLabel: {
    color: '#6F6F6F',
    opacity: 0.6,
    fontSize: '12px',
    fontWeight: 600,
    //width: '70%'
  },
  note: {
    color: '#6F6F6F',
    fontSize: '14px',
    marginTop: '18px',

    '& span': {
      '& span': {
        fontWeight: 'bold'
      }
    }
  },
  checkBox: {
    padding: 0
  },
  inputRowWrapper: {
    width: '100%',

    '@media (min-width: 768px)': {
      width: '45%'
    }
  },
  errorMessage: {
    color: 'red',
    fontSize: '12px',
    marginTop: '5px'
  },
  disable: {
    opacity: '50%',
    pointerEvents: 'none'
  },
  popWrapper: {
    padding: '30px',
    color: '#565657',
    fontSize: '16px',
    textAlign: 'center'
  },
  ackButton: {
    width: '45%',
    height: '36px',
    textTransform: 'capitalize'
  },
  popText: {
    fontSize: '16px',
    color: '#565657',
    margin: '24px 0'
  },
  dateInput: {
    position: 'relative'
  },
  popupTitle: {
    color: '#565657',
    fontSize: '20px',
    fontWeight: 'bold'
  },
  buttonGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '70%',
    margin: 'auto'
  },
  staticMargin: {
    marginLeft: '3%'
  },
  headerButtonGroup: {
    display: 'flex',
    width: '50%',
    justifyContent: 'flex-end'
  },
  tableWrapper: {
    padding: '20px'
  },
  tableCell: {
    '& p': {
      fontSize: '14px'
    }
  },
  calendarPopupContainer: {
    padding: '30px'
  },
  calendarHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    '& p': {
      fontSize: '20px',
      color: '#545456',
      fontWeight: 'bold'
    }
  },
  tableHeading: {
    '& button': {
      fontSize: '14px'
    }
  },
  eventName: {
    width: '20%',
    '& button': {
      marginLeft: '10%'
    }
  },
  eventType: {
    width: '15%'
  },
  eventTime: {
    width: '20%',

    '@media (max-width: 768px)': {
      width: '30%',
    }
  },
  systemsParticipated: {
    textAlign: 'center',
    '& p': {
      width: '170px',

      '@media (max-width: 768px)': {
        width: '100px',
      }
    },
  },
  popupWrapper: {
    minWidth: '500px',

    '@media (min-width: 1440px)': {
      minWidth: '950px'
    },

    '@media (min-width: 1024px)': {
      minWidth: '750px'
    }
  },
  pointer: {
    cursor: 'pointer'
  },
  popupHeader: {
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  customRowWrapper: {
    width: '100%',
  },
  typeInput: {
    position: 'relative',
    marginTop: '20px'
  },
  customTypeInput: {
    width: '45%'
  },
  accordianWrapper: {
    backgroundColor: '#F0F0F0',
  },
  typeBoxWrapper: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '10px',
    padding: '10px',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    border: '0.5px solid #D6D6D6',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#F37320',
      backgroundColor: '#FFFAF7'
    }
  },
  eventNameTitle: {
    color: '#545455',
    fontSize: '14px',
  },
  eventTypeDescription: {
    fontSize: '12px',
    color: '#545455',
    '& ol': {
      padding: '0 2rem'
    }
  },
  subTypeBoxWrapper: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '10px',
    padding: '10px',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    border: '0.5px solid #D6D6D6',
    cursor: 'pointer',
    maxWidth: '350px',
    minHeight: '400px',
    '&:hover': {
      borderColor: '#F37320',
      backgroundColor: '#FFFAF7'
    }
  },
  hoveredEventBox: {
    borderColor: '#F37320',
    backgroundColor: '#FFFAF7'
  },
  customPopper: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: `0px 6px 12px #0000002E`,
    fontSize: 11,
  },
  customPopperText: {
    color: '#6F6F6F',
    opacity: 1,
    padding: '8px'
  },
  scheduledPowerText: {
    color: '#F37320',
    fontSize: '12px'
  }
}))

export { useStyles }